(() => {
  const emailBannerInit = () => {
    const emailBanner = document.querySelector('#email-banner');

    if (!emailBanner) return;

    // gsap.set(emailBanner, { yPercent: 100 });

    const checkLocalStorage = () => {
      const value = localStorage.getItem('emailBannerDismissed');
      if (value === null || value.length === 0) {
        return false;
      }
      return true;
    };

    if (checkLocalStorage()) return;

    const handleInputPlaceholder = () => {
      const bannerInput = emailBanner.querySelector('form input');
      if (!bannerInput || bannerInput.getAttribute('placeholder')) return;
      bannerInput.setAttribute('placeholder', 'Email Address');
    };

    const bannerTimeline = gsap.timeline({
      paused: true,
      onComplete: handleInputPlaceholder,
    })
      .to(emailBanner, {
        bottom: '0',
        yPercent: 0,
        duration: 0.5,
        delay: 3,
      });
    bannerTimeline.play();

    const bannerClose = (event) => {
      event.stopPropagation(event);
      bannerTimeline.reverse();
      localStorage.setItem('emailBannerDismissed', 'true');
    };

    const bannerCloseButton = emailBanner.querySelector('#email-banner-button');
    bannerCloseButton.addEventListener('click', bannerClose);
  };

  if (document.readyState === 'complete' || (document.readyState !== 'loading' && !document.documentElement.doScroll)) {
    emailBannerInit();
  } else {
    document.addEventListener('DOMContentLoaded', emailBannerInit);
  }
})();
